import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { API, get } from "../../../../config";

export const getFirmSettingDetail = async () => {
  try {
    const { data } = await get(`${API.ACCOUNTING_FIRM_SETTINGS}`);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const useStateList = () => {
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setStateLoading(true);
      const { data } = await get(API.GET_STATE_LIST);
      setStateLoading(false);
      setStateList(data.data);
    } catch (e) {
      setStateList([]);
      setStateLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    stateList,
    stateLoading,
  };
};

export const useSuburbListE = (id) => {
  const [suburbList, setSuburbList] = useState([]);
  const [shippingSuburbList, setShippingSuburbList] = useState([]);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbLoading2, setSuburbLoading2] = useState(false);
  const init = useCallback(async () => {
    try {
      if (id) {
        setSuburbLoading(true);
        setSuburbLoading2(true);
        const { data } = await get(`${API.GET_SUBURB_LIST}?state=${id}`);
        setSuburbLoading(false);
        setSuburbLoading2(false);
        setSuburbList(data.data);
        setShippingSuburbList(data.data);
      }
    } catch (e) {
      setSuburbList([]);
      setShippingSuburbList([]);
      setSuburbLoading(false);
      setSuburbLoading2(false);
    }
  }, [id]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    suburbList,
    suburbLoading,
    suburbLoading2,
    shippingSuburbList,
    setSuburbList,
    setShippingSuburbList,
  };
};

export const useSuburbList = () => {
  const [suburbList, setSuburbList] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [suburbLoading1, setSuburbLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      if (selectedState) {
        setSuburbLoading(true);
        const { data } = await get(
          `${API.GET_SUBURB_LIST}?state=${selectedState}`
        );
        setSuburbLoading(false);
        setSuburbList(data.data);
      }
    } catch (e) {
      setSuburbList([]);
      setSuburbLoading(false);
    }
  }, [selectedState]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    suburbList,
    handleStateSelect: (value) => {
      setSuburbList([]);
      setSelectedState(value);
    },
    suburbLoading1,
    setSuburbList,
    selectedState,
  };
};
